import React, { Component } from 'react';



class CategorieApplicative extends Component {

  constructor(props) {
    super(props);

    this.state = {


      isLoading: false,
      error: null,


    };



  }

  componentDidMount() {
    this.setState({ isLoading: true });


    //console.log("componentDidMount CategorieApplicative");
  }














  render() {
    //console.log("render CategorieApplicative");

    const applicazioni = this.props.data;

    //console.log("applicazioni",applicazioni);

    //console.log("this.props.selectedApplicazione",this.props.selectedApplicazione);

    let labels = JSON.parse(this.props.labels);

    console.log("tecnologiex", this.props.tecnologie);
    
    let color = "grey";

    if ( this.props.tecnologie == 830) {
      color = "orange";
    }


    return (

      <div className="home-categorie-applicative" >

        <div className="row no-gutters">
          <div className="col-md-12">
            <div className="sottotitolo text-left ">{labels['Seleziona una categoria applicativa']}</div>
          </div>
        </div>


        <div className={"color-" + color + " container-no "} >

          <div className="row vertical-padding-20">

          {applicazioni.map(applicazione =>
            <div className="col-sm">

              <a href={applicazione.link} className="text-light">
      	        <div className={((this.props.selectedApplicazione==applicazione.term_id) && "active") + " categorie-applicative-image-item  mb-2 border border-primary border-3 text-center ricerca-di-micro-tossine"}>

                { (applicazione.image) ? ( 
                  <div className="" >
                    <div className="applicazioni-image ">
                    <img src={applicazione.image} />
                    </div>

                    <div className=" small font-weight-light text-center text-uppercase" dangerouslySetInnerHTML={{__html: applicazione.name}} />
                    
                    
                  </div>
                  
                ) : (
                  <div className="centered-content small font-weight-light text-uppercase" dangerouslySetInnerHTML={{__html: applicazione.name}} />
                )
                }

      						
                  
                  </div>

                  

      					</a>

            </div>
            )}








          </div>


        </div>


      </div>




    );



  }

}

export default CategorieApplicative;
